module.exports = __webpack_public_path__ + "static/media/untere_falz.9aa5bc68.jpg";